import React from 'react';

import Headline from '@skippay/core/components/Headline';
import Link from '@skippay/core/components/Link';
import ModalContent from '@skippay/core/components/ModalContent';
import Text from '@skippay/core/components/Text';
import useInitialCountryLocale from '@skippay/core/hooks/useInitialCountryLocale';
import { FormattedMessage } from '@skippay/core/i18n/intl';

import { PARTNERS, ROUTES } from 'constants/routes';

function ExtendedMarketingModal(props) {
	const { locale } = useInitialCountryLocale();
	return (
		<ModalContent
			Header={
				<Headline md>
					<FormattedMessage
						defaultMessage="Více o zpracování osobních údajů"
						id="ExtendedMarketingModal.moreAboutPersonalDataProcessing"
					/>
				</Headline>
			}
			closeBtnHandler={props.modalClose}
			testId="moreInfoExtendedMarketing"
		>
			<div className="text-left">
				<Text>
					<FormattedMessage
						defaultMessage="Pokud nám udělíte svůj souhlas, používáme a automaticky zpracováváme vaše identifikační a kontaktní údaje, vaše nastavení a údaje o platbách pro poskytování přizpůsobených nabídek nás i našich {linkPartners}. Nabídky vám můžeme zaslat e‑mailem, textovou zprávou či poštou, sdělit je po telefonu nebo jinými elektronickými prostředky. Udělení souhlasu je dobrovolné a nejste povinni nám jej poskytnout. Udělený souhlas můžete kdykoli odvolat. Kompletní znění souhlasu a více informací o zpracování osobních údajů, zejména o předávání údajů mimo EU a vašich právech, najdete na {linkPrivacyProtection} v části B.8."
						id="MarketingExtendedConsentCheckboxField.DataProcessingExplanation"
						values={{
							linkPrivacyProtection: (
								<Link
									openInPopupBrowser
									target="_blank"
									testId="privacyProtection"
									analyticsId="privacyProtection"
									to={
										process.env.MOB_APP_BUILD
											? ROUTES(locale).informationMemorandumGenerated
											: ROUTES(locale).informationMemorandum
									}
									isExternal
								>
									<FormattedMessage
										defaultMessage="Ochrana soukromí"
										id="MarketingExtendedConsentCheckboxField.linkPrivacyProtection"
									/>
								</Link>
							),
							linkPartners: (
								<Link to={PARTNERS} testId="partners" analyticsId="partners" isExternal>
									<FormattedMessage
										defaultMessage="partnerů"
										id="MarketingExtendedConsentCheckboxField.linkPartners"
									/>
								</Link>
							),
						}}
					/>
				</Text>
			</div>
		</ModalContent>
	);
}

export default ExtendedMarketingModal;
